module.exports = __webpack_public_path__ + "static/media/logo.3e0249c2.png";